export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20fashion%20collage%20with%20floating%20sneakers%20hoodies%20caps%20and%20accessories%20on%20warm%20terracotta%20gradient%20background%2C%20modern%20editorial%20design%20with%20soft%20geometric%20shapes%2C%20dreamy%20atmospheric%20lighting%2C%20luxury%20lifestyle%20magazine%20aesthetic%2C%20brand%20campaign%20style%20photography%20with%20rich%20earthy%20tones%20and%20elegant%20shadows&width=1800&height=1000&seq=hero-bg-v2-001&orientation=landscape"
          alt="Hoobuy Spreadsheet - Produtos da China"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full text-center px-4 md:px-8 pt-20">
        <p className="text-xs md:text-sm text-background-50/90 font-medium tracking-widest uppercase mb-4">
          Atualizado 2025
        </p>
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight max-w-4xl mx-auto drop-shadow-lg">
          Hoobuy Sheet Atualizado 2025
        </h1>
        <p className="font-heading text-2xl md:text-4xl lg:text-5xl text-background-50/95 italic mt-2 mb-6 drop-shadow-md">
          Sua Lista Completa de Produtos da China
        </p>
        <p className="text-sm md:text-base text-background-50/85 max-w-xl mx-auto leading-relaxed mb-10 drop-shadow">
          Descubra o melhor Hoobuy Spreadsheet com produtos exclusivos, sneakers, streetwear e itens virais
          diretamente de agentes de compra da China.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-background-50 text-foreground-900 text-sm md:text-base font-semibold rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            Hoobuy Sheet
            <span className="w-4 h-4 inline-flex items-center justify-center ml-2">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-accent-600 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-accent-700 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
          >
            Buy It Now
            <span className="w-4 h-4 inline-flex items-center justify-center ml-2">
              <i className="ri-shopping-cart-line"></i>
            </span>
          </a>
        </div>
      </div>

      <div className="relative z-10 w-full mt-16 md:mt-20 px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://readdy.ai/api/search-image?query=Diagonal%20arrangement%20of%20trendy%20fashion%20items%20including%20colorful%20sneakers%20oversized%20hoodie%20baseball%20cap%20and%20tote%20bag%20on%20textured%20concrete%20surface%2C%20bright%20natural%20sunlight%20casting%20dramatic%20shadows%2C%20urban%20streetwear%20editorial%20photography%2C%20vibrant%20yet%20grounded%20color%20palette&width=1600&height=700&seq=hero-showcase-v2-002&orientation=landscape"
              alt="Hoobuy Sheet Products Showcase"
              className="w-full h-[200px] md:h-[320px] object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}